/*
 *
 *  sagas
 *
 */

import { call, take, put, race, all } from "redux-saga/effects";

import {
  LOAD_PAYMENT_IN_DETAILS_RECORDS_META_DATA,
  LOAD_PAYMENT_IN_DETAILS,
  CREATE_PAYMENT_IN_DETAILS,
  UPDATE_PAYMENT_IN_DETAILS,
  DELETE_PAYMENT_IN_DETAILS,
  LOAD_PAYMENT_SETTLED_LIST,
  LOAD_PARTY_ACCOUNT_LIST,
  LOAD_PAYMENT_IN_DETAILS_REPORT,
} from "./constants";

import {
  loadPaymentInList,
  loadPaymentInListSuccess,
  loadPaymentInListError,
  createPaymentInListSuccess,
  createPaymentInListError,
  updatePaymentInListSuccess,
  updatePaymentInListError,
  deletePaymentInListSuccess,
  deletePaymentInListError,
  loadPaymentInListRecordsMetaDataError,
  loadPaymentInListRecordsMetaDataSuccess,
  loadPaymentSettledList,
  loadPaymentSettledListSuccess,
  loadPaymentSettledListError,
  loadPartyAccountList,
  loadPartyAccountListSuccess,
  loadPartyAccountListError,
  loadPaymentInReportList,
  loadPaymentInReportListSuccess,
  loadPaymentInReportListError,
} from "./actions";

import {
  loadPaymentInDetails,
  createPaymentInDetails,
  updatePaymentInDetails,
  deletePaymentInDetails,
  loadRecordsMetaData,
  loadPaymentSettledDetails,
  loadPartyAccountDetails,
  loadPaymentInReportDetails,
} from "./remotes";

function* loadPaymentInListSaga() {
  while (true) {
    const load = yield race({
      explicitLoad: take(LOAD_PAYMENT_IN_DETAILS),
    });

    const { explicitLoad } = load;
    const { paymentDetails } = explicitLoad || {};
    yield put(loadPaymentInList(explicitLoad)); // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadPaymentInDetails, paymentDetails);

        if (result) {
          yield put(loadPaymentInListSuccess(result));
        }
      } catch (error) {
        yield put(
          loadPaymentInListError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}

function* loadPaymentInReportSaga() {
  while (true) {
    const load = yield race({
      explicitLoad: take(LOAD_PAYMENT_IN_DETAILS_REPORT),
    });

    const { explicitLoad } = load;
    const { paymentDetails } = explicitLoad || {};
    yield put(loadPaymentInReportList(explicitLoad)); // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadPaymentInReportDetails, paymentDetails);

        if (result) {
          yield put(loadPaymentInReportListSuccess(result));
        }
      } catch (error) {
        yield put(
          loadPaymentInReportListError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}

function* loadPaymentSettledDetailsSaga() {
  while (true) {
    const load = yield race({
      explicitLoad: take(LOAD_PAYMENT_SETTLED_LIST),
    });

    const { explicitLoad } = load;
    const { paymentDetails } = explicitLoad || {};
    yield put(loadPaymentSettledList(explicitLoad)); // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadPaymentSettledDetails, paymentDetails);

        if (result) {
          yield put(loadPaymentSettledListSuccess(result));
        }
      } catch (error) {
        yield put(
          loadPaymentSettledListError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}

function* loadPartyAccountDetailsSaga() {
  while (true) {
    const load = yield race({
      explicitLoad: take(LOAD_PARTY_ACCOUNT_LIST),
    });

    const { explicitLoad } = load;
    const { paymentDetails } = explicitLoad || {};
    yield put(loadPartyAccountList(explicitLoad)); // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadPartyAccountDetails, paymentDetails);

        if (result) {
          yield put(loadPartyAccountListSuccess(result));
        }
      } catch (error) {
        yield put(
          loadPartyAccountListError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}

function* createPaymentSaga() {
  while (true) {
    const { create } = yield race({
      create: take(CREATE_PAYMENT_IN_DETAILS),
    });

    const { paymentDetails } = create || {};

    if (create) {
      try {
        const result = yield call(createPaymentInDetails, paymentDetails);
        if (result) {
          yield put(createPaymentInListSuccess(result.data));
          // console.log(result.data, "result");
        }
      } catch (error) {
        yield put(
          createPaymentInListError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}

function* updatePaymentSaga() {
  while (true) {
    const { update } = yield race({
      update: take(UPDATE_PAYMENT_IN_DETAILS),
    });
    const { paymentDetails } = update || {};

    if (update) {
      try {
        const result = yield call(updatePaymentInDetails, paymentDetails);
        if (result) {
          yield put(updatePaymentInListSuccess(result.data));
          // console.log(result.data, "result");
        }
      } catch (error) {
        yield put(
          updatePaymentInListError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}
function* deletePaymentSaga() {
  while (true) {
    const { create } = yield race({
      create: take(DELETE_PAYMENT_IN_DETAILS),
    });
    const { paymentDetails } = create || {};

    if (create) {
      try {
        const result = yield call(deletePaymentInDetails, paymentDetails);
        if (result) {
          yield put(deletePaymentInListSuccess(result.data));
          // console.log(result.data, "result");
        }
      } catch (error) {
        yield put(
          deletePaymentInListError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}

function* loadPaymentDetailsMetaDataSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    yield race({
      metaData: take(LOAD_PAYMENT_IN_DETAILS_RECORDS_META_DATA),
    });

    try {
      const paymentMode = yield call(
        loadRecordsMetaData,
        "getpaymentmode",
        "post"
      );

      let recordsMetaData = {
        paymentModeOptions:
          (paymentMode &&
            paymentMode &&
            paymentMode.length > 0 &&
            paymentMode.map((c) =>
              Object.assign(
                {},
                {
                  label: c.paymentModeName,
                  shortCode: c.shortCode,
                  value: c._id,
                }
              )
            )) ||
          [],
      };

      yield put(loadPaymentInListRecordsMetaDataSuccess(recordsMetaData));
    } catch (error) {
      yield put(
        loadPaymentInListRecordsMetaDataError(
          (error && error.response && error.response.message) ||
            "Fetch Dropdown Records Failed"
        )
      );
    }
  }
}

export default function* recordsSaga() {
  yield all([
    loadPaymentInListSaga(),
    loadPaymentSettledDetailsSaga(),
    deletePaymentSaga(),
    updatePaymentSaga(),
    loadPartyAccountDetailsSaga(),
    createPaymentSaga(),
    loadPaymentDetailsMetaDataSaga(),
    loadPaymentInReportSaga(),
  ]);
}
